<template>
  <div class="FamilyAppointmentView">

    <h1 class="m-label m-label-custom" @click="switchV('column')" v-bind:class="{ 'slideActive': column }" v-ripple>項目</h1>
    <template v-if="column">
      <div style="display: flex; flex-wrap: wrap">
        <btn class="m-btn--column" @click.native="reset()">RESET</btn>
        <btn class="m-btn--column" @click.native="all()">ALL</btn>
        <btn class="m-btn--column" @click.native="switchV('id')" v-bind:class="{ 'active': id }">ID</btn>
        <btn class="m-btn--column" @click.native="switchV('family_id')" v-bind:class="{ 'active': family_id }">家庭ID</btn>
        <btn class="m-btn--column" @click.native="switchV('user_id')" v-bind:class="{ 'active': user_id }">User ID</btn>
        <btn class="m-btn--column" @click.native="switchV('state')" v-bind:class="{ 'active': state }">状態</btn>
        <btn class="m-btn--column" @click.native="switchV('name')" v-bind:class="{ 'active': name }">名前</btn>
        <btn class="m-btn--column" @click.native="switchV('kana')" v-bind:class="{ 'active': kana }">かな</btn>
        <btn class="m-btn--column" @click.native="switchV('zip')" v-bind:class="{ 'active': zip }">郵便番号</btn>
        <btn class="m-btn--column" @click.native="switchV('pref')" v-bind:class="{ 'active': pref }">都道府県</btn>
        <btn class="m-btn--column" @click.native="switchV('address')" v-bind:class="{ 'active': address }">住所</btn>
        <btn class="m-btn--column" @click.native="switchV('tel1')" v-bind:class="{ 'active': tel1 }">TEL1</btn>
        <btn class="m-btn--column" @click.native="switchV('tel2')" v-bind:class="{ 'active': tel2 }">TEL2</btn>
        <btn class="m-btn--column" @click.native="switchV('contact_date')" v-bind:class="{ 'active': contact_date }">問い合わせ日</btn>
        <btn class="m-btn--column" @click.native="switchV('support')" v-bind:class="{ 'active': support }">AP結果</btn>
        <btn class="m-btn--column" @click.native="switchV('result')" v-bind:class="{ 'active': result }">営業結果</btn>
        <btn class="m-btn--column" @click.native="switchV('acquisition_date')" v-bind:class="{ 'active': acquisition_date }">取得日</btn>
        <btn class="m-btn--column" @click.native="switchV('ap_type')" v-bind:class="{ 'active': ap_type }">AP種類</btn>
        <btn class="m-btn--column" @click.native="switchV('medium')" v-bind:class="{ 'active': medium }">媒体</btn>
        <btn class="m-btn--column" @click.native="switchV('hp_type')" v-bind:class="{ 'active': hp_type }">HP種類</btn>
        <btn class="m-btn--column" @click.native="switchV('office_id')" v-bind:class="{ 'active': office_id }">営業所</btn>
        <btn class="m-btn--column" @click.native="switchV('gender')" v-bind:class="{ 'active': gender }">性別</btn>
        <btn class="m-btn--column" @click.native="switchV('school_type')" v-bind:class="{ 'active': school_type }">公/国/私</btn>
        <btn class="m-btn--column" @click.native="switchV('school_stage')" v-bind:class="{ 'active': school_stage }">小/中/高/幼</btn>
        <btn class="m-btn--column" @click.native="switchV('grade')" v-bind:class="{ 'active': grade }">学年</btn>
        <btn class="m-btn--column" @click.native="switchV('memo')" v-bind:class="{ 'active': memo }">メモ</btn>
        <btn class="m-btn--column" @click.native="switchV('dm')" v-bind:class="{ 'active': dm }">DM届いた月</btn>
        <btn class="m-btn--column" @click.native="switchV('shop_type')" v-bind:class="{ 'active': shop_type }">店種類</btn>
        <btn class="m-btn--column" @click.native="switchV('shop_name')" v-bind:class="{ 'active': shop_name }">店名</btn>
        <btn class="m-btn--column" @click.native="switchV('hp_browse')" v-bind:class="{ 'active': hp_browse }">HP閲覧</btn>
        <btn class="m-btn--column" @click.native="switchV('visit_date')" v-bind:class="{ 'active': visit_date }">訪問日</btn>
        <btn class="m-btn--column" @click.native="switchV('note')" v-bind:class="{ 'active': note }">備考</btn>
        <btn class="m-btn--column" @click.native="switchV('created_at')" v-bind:class="{ 'active': created_at }">作成日</btn>
      </div>
    </template>

    <!-- <div class="index&#45;box" @scroll="offset"> -->
    <div class="index-box">
      <table-c>

        <tr-c slot="tr-th">
          <template v-if="id"><td-c><input v-model="searchQuery.id" type="text" @keyup="" placeholder="検索"></td-c></template>
          <template v-if="family_id"><td-c><input v-model="searchQuery.family_id" type="text" @keyup=""></td-c></template>
          <template v-if="user_id"><td-c><input v-model="searchQuery.user_id" type="text" @keyup=""></td-c></template>
          <template v-if="state"><td-c><input v-model="searchQuery.state" type="text" @keyup=""></td-c></template>
          <template v-if="name"><td-c><input v-model="searchQuery.name" type="text" @keyup=""></td-c></template>
          <template v-if="kana"><td-c><input v-model="searchQuery.kana" type="text" @keyup=""></td-c></template>
          <template v-if="zip"><td-c><input v-model="searchQuery.zip" type="text" @keyup=""></td-c></template>
          <template v-if="pref"><td-c><input v-model="searchQuery.pref" type="text" @keyup=""></td-c></template>
          <template v-if="address"><td-c><input v-model="searchQuery.address" type="text" @keyup=""></td-c></template>
          <template v-if="tel1"><td-c><input v-model="searchQuery.tel1" type="text" @keyup=""></td-c></template>
          <template v-if="tel2"><td-c><input v-model="searchQuery.tel2" type="text" @keyup=""></td-c></template>
          <template v-if="contact_date"><td-c><input v-model="searchQuery.contact_date" type="text" @keyup=""></td-c></template>
          <template v-if="support"><td-c><input v-model="searchQuery.support" type="text" @keyup=""></td-c></template>
          <template v-if="result"><td-c><input v-model="searchQuery.result" type="text" @keyup=""></td-c></template>
          <template v-if="acquisition_date"><td-c><input v-model="searchQuery.acquisition_date" type="text" @keyup=""></td-c></template>
          <template v-if="ap_type"><td-c><input v-model="searchQuery.ap_type" type="text" @keyup=""></td-c></template>
          <template v-if="medium"><td-c><input v-model="searchQuery.medium" type="text" @keyup=""></td-c></template>
          <template v-if="hp_type"><td-c><input v-model="searchQuery.hp_type" type="text" @keyup=""></td-c></template>
          <template v-if="office_id"><td-c><input v-model="searchQuery.office_id" type="text" @keyup=""></td-c></template>
          <template v-if="gender"><td-c><input v-model="searchQuery.gender" type="text" @keyup=""></td-c></template>
          <template v-if="school_type"><td-c><input v-model="searchQuery.school_type" type="text" @keyup=""></td-c></template>
          <template v-if="school_stage"><td-c><input v-model="searchQuery.school_stage" type="text" @keyup=""></td-c></template>
          <template v-if="grade"><td-c><input v-model="searchQuery.grade" type="text" @keyup=""></td-c></template>
          <template v-if="memo"><td-c><input v-model="searchQuery.memo" type="text" @keyup=""></td-c></template>
          <template v-if="dm"><td-c><input v-model="searchQuery.dm" type="text" @keyup=""></td-c></template>
          <template v-if="shop_type"><td-c><input v-model="searchQuery.shop_type" type="text" @keyup=""></td-c></template>
          <template v-if="shop_name"><td-c><input v-model="searchQuery.shop_name" type="text" @keyup=""></td-c></template>
          <template v-if="hp_browse"><td-c><input v-model="searchQuery.hp_browse" type="text" @keyup=""></td-c></template>
          <template v-if="visit_date"><td-c><input v-model="searchQuery.visit_date" type="text" @keyup=""></td-c></template>
          <template v-if="note"><td-c><input v-model="searchQuery.note" type="text" @keyup=""></td-c></template>
          <template v-if="created_at"><td-c><input v-model="searchQuery.created_at" type="text" @keyup=""></td-c></template>
        </tr-c>

        <tr-c slot="tr-th">
          <template v-if="id"><td-c><input v-model="notSearchQuery.id" type="text" @keyup="" placeholder="除外"></td-c></template>
          <template v-if="family_id"><td-c><input v-model="notSearchQuery.family_id" type="text" @keyup=""></td-c></template>
          <template v-if="user_id"><td-c><input v-model="notSearchQuery.user_id" type="text" @keyup=""></td-c></template>
          <template v-if="state"><td-c><input v-model="notSearchQuery.state" type="text" @keyup=""></td-c></template>
          <template v-if="name"><td-c><input v-model="notSearchQuery.name" type="text" @keyup=""></td-c></template>
          <template v-if="kana"><td-c><input v-model="notSearchQuery.kana" type="text" @keyup=""></td-c></template>
          <template v-if="zip"><td-c><input v-model="notSearchQuery.zip" type="text" @keyup=""></td-c></template>
          <template v-if="pref"><td-c><input v-model="notSearchQuery.pref" type="text" @keyup=""></td-c></template>
          <template v-if="address"><td-c><input v-model="notSearchQuery.address" type="text" @keyup=""></td-c></template>
          <template v-if="tel1"><td-c><input v-model="notSearchQuery.tel1" type="text" @keyup=""></td-c></template>
          <template v-if="tel2"><td-c><input v-model="notSearchQuery.tel2" type="text" @keyup=""></td-c></template>
          <template v-if="contact_date"><td-c><input v-model="notSearchQuery.contact_date" type="text" @keyup=""></td-c></template>
          <template v-if="support"><td-c><input v-model="notSearchQuery.support" type="text" @keyup=""></td-c></template>
          <template v-if="result"><td-c><input v-model="notSearchQuery.result" type="text" @keyup=""></td-c></template>
          <template v-if="acquisition_date"><td-c><input v-model="notSearchQuery.acquisition_date" type="text" @keyup=""></td-c></template>
          <template v-if="ap_type"><td-c><input v-model="notSearchQuery.ap_type" type="text" @keyup=""></td-c></template>
          <template v-if="medium"><td-c><input v-model="notSearchQuery.medium" type="text" @keyup=""></td-c></template>
          <template v-if="hp_type"><td-c><input v-model="notSearchQuery.hp_type" type="text" @keyup=""></td-c></template>
          <template v-if="office_id"><td-c><input v-model="notSearchQuery.office_id" type="text" @keyup=""></td-c></template>
          <template v-if="gender"><td-c><input v-model="notSearchQuery.gender" type="text" @keyup=""></td-c></template>
          <template v-if="school_type"><td-c><input v-model="notSearchQuery.school_type" type="text" @keyup=""></td-c></template>
          <template v-if="school_stage"><td-c><input v-model="notSearchQuery.school_stage" type="text" @keyup=""></td-c></template>
          <template v-if="grade"><td-c><input v-model="notSearchQuery.grade" type="text" @keyup=""></td-c></template>
          <template v-if="memo"><td-c><input v-model="notSearchQuery.memo" type="text" @keyup=""></td-c></template>
          <template v-if="dm"><td-c><input v-model="notSearchQuery.dm" type="text" @keyup=""></td-c></template>
          <template v-if="shop_type"><td-c><input v-model="notSearchQuery.shop_type" type="text" @keyup=""></td-c></template>
          <template v-if="shop_name"><td-c><input v-model="notSearchQuery.shop_name" type="text" @keyup=""></td-c></template>
          <template v-if="hp_browse"><td-c><input v-model="notSearchQuery.hp_browse" type="text" @keyup=""></td-c></template>
          <template v-if="visit_date"><td-c><input v-model="notSearchQuery.visit_date" type="text" @keyup=""></td-c></template>
          <template v-if="note"><td-c><input v-model="notSearchQuery.note" type="text" @keyup=""></td-c></template>
          <template v-if="created_at"><td-c><input v-model="notSearchQuery.created_at" type="text" @keyup=""></td-c></template>
        </tr-c>

        <tr-c slot="tr-th">
          <template v-if="id"><th-c @click.native='sort("id")'>ID</th-c></template>
          <template v-if="family_id"><th-c @click.native='sort("family_id")'>家庭ID</th-c></template>
          <template v-if="user_id"><th-c @click.native='sort("user_id")'>User ID</th-c></template>
          <template v-if="state"><th-c @click.native='sort("state")'>状態</th-c></template>
          <template v-if="name"><th-c @click.native='sort("name")'>名前</th-c></template>
          <template v-if="kana"><th-c @click.native='sort("kana")'>かな</th-c></template>
          <template v-if="zip"><th-c @click.native='sort("zip")'>郵便番号</th-c></template>
          <template v-if="pref"><th-c @click.native='sort("pref")'>都道府県</th-c></template>
          <template v-if="address"><th-c @click.native='sort("address")'>住所</th-c></template>
          <template v-if="tel1"><th-c @click.native='sort("tel1")'>TEL1</th-c></template>
          <template v-if="tel2"><th-c @click.native='sort("tel2")'>TEL2</th-c></template>
          <template v-if="contact_date"><th-c @click.native='sort("contact_date")'>問い合わせ日</th-c></template>
          <template v-if="support"><th-c @click.native='sort("support")'>AP結果</th-c></template>
          <template v-if="result"><th-c @click.native='sort("result")'>営業結果</th-c></template>
          <template v-if="acquisition_date"><th-c @click.native='sort("acquisition_date")'>取得日</th-c></template>
          <template v-if="ap_type"><th-c @click.native='sort("ap_type")'>AP種類</th-c></template>
          <template v-if="medium"><th-c @click.native='sort("medium")'>媒体</th-c></template>
          <template v-if="hp_type"><th-c @click.native='sort("hp_type")'>HP種類</th-c></template>
          <template v-if="office_id"><th-c @click.native='sort("office_id")'>営業所</th-c></template>
          <template v-if="gender"><th-c @click.native='sort("gender")'>性別</th-c></template>
          <template v-if="school_type"><th-c @click.native='sort("school_type")'>公/国/私</th-c></template>
          <template v-if="school_stage"><th-c @click.native='sort("school_stage")'>小/中/高/幼</th-c></template>
          <template v-if="grade"><th-c @click.native='sort("grade")'>学年</th-c></template>
          <template v-if="memo"><th-c @click.native='sort("memo")'>メモ</th-c></template>
          <template v-if="dm"><th-c @click.native='sort("dm")'>DM届いた月</th-c></template>
          <template v-if="shop_type"><th-c @click.native='sort("shop_type")'>店種類</th-c></template>
          <template v-if="shop_name"><th-c @click.native='sort("shop_name")'>店名</th-c></template>
          <template v-if="hp_browse"><th-c @click.native='sort("hp_browse")'>HP閲覧</th-c></template>
          <template v-if="visit_date"><th-c @click.native='sort("visit_date")'>訪問日</th-c></template>
          <template v-if="note"><th-c @click.native='sort("note")'>備考</th-c></template>
          <template v-if="created_at"><th-c @click='sort("created_at")'>作成日</th-c></template>
        </tr-c>

        <tr-c @click.native='linkFamilyAppointment(list)' slot="tr-td" v-for="(list, index) in notFilteredFamilyAppointments" :key="index.id" class="tr_hover">
          <template v-if="id"><td-c>{{list.id}}</td-c></template>
          <template v-if="family_id"><td-c>{{list.family_id}}</td-c></template>
          <template v-if="user_id"><td-c>{{list.user_id}}</td-c></template>
          <template v-if="state">
            <td-c v-if="list.state === 0">未選択</td-c>
            <td-c v-if="list.state === 1">新規</td-c>
            <td-c v-if="list.state === 2">保留上げ</td-c>
            <td-c v-if="list.state === 3">書換</td-c>
            <td-c v-if="list.state === 4">内容変更</td-c>
            <td-c v-if="list.state === 5">引継</td-c>
          </template>
          <template v-if="name"><td-c>{{list.name}}</td-c></template>
          <template v-if="kana"><td-c>{{list.kana}}</td-c></template>
          <template v-if="zip"><td-c>{{list.zip}}</td-c></template>
          <template v-if="pref">
            <td-c>
              <template v-if="list.pref === 0">未選択</template>
              <template v-if="list.pref === 1">北海道</template>
              <template v-if="list.pref === 2">青森県</template>
              <template v-if="list.pref === 3">秋田県</template>
              <template v-if="list.pref === 4">岩手県</template>
              <template v-if="list.pref === 5">山形県</template>
              <template v-if="list.pref === 6">宮城県</template>
              <template v-if="list.pref === 7">福島県</template>
              <template v-if="list.pref === 8">栃木県</template>
              <template v-if="list.pref === 9">山梨県</template>
              <template v-if="list.pref === 10">群馬県</template>
              <template v-if="list.pref === 11">茨城県</template>
              <template v-if="list.pref === 12">千葉県</template>
              <template v-if="list.pref === 13">埼玉県</template>
              <template v-if="list.pref === 14">東京都</template>
              <template v-if="list.pref === 15">神奈川県</template>
              <template v-if="list.pref === 16">静岡県</template>
              <template v-if="list.pref === 17">長野県</template>
              <template v-if="list.pref === 18">愛知県</template>
              <template v-if="list.pref === 19">岐阜県</template>
              <template v-if="list.pref === 20">新潟県</template>
              <template v-if="list.pref === 21">富山県</template>
              <template v-if="list.pref === 22">石川県</template>
              <template v-if="list.pref === 23">福井県</template>
              <template v-if="list.pref === 24">滋賀県</template>
              <template v-if="list.pref === 25">京都府</template>
              <template v-if="list.pref === 26">三重県</template>
              <template v-if="list.pref === 27">和歌山県</template>
              <template v-if="list.pref === 28">奈良県</template>
              <template v-if="list.pref === 29">大阪府</template>
              <template v-if="list.pref === 30">兵庫県</template>
              <template v-if="list.pref === 31">鳥取県</template>
              <template v-if="list.pref === 32">島根県</template>
              <template v-if="list.pref === 33">岡山県</template>
              <template v-if="list.pref === 34">広島県</template>
              <template v-if="list.pref === 35">山口県</template>
              <template v-if="list.pref === 36">高知県</template>
              <template v-if="list.pref === 37">徳島県</template>
              <template v-if="list.pref === 38">香川県</template>
              <template v-if="list.pref === 39">愛媛県</template>
              <template v-if="list.pref === 40">福岡県</template>
              <template v-if="list.pref === 41">佐賀県</template>
              <template v-if="list.pref === 42">長崎県</template>
              <template v-if="list.pref === 43">熊本県</template>
              <template v-if="list.pref === 44">宮崎県</template>
              <template v-if="list.pref === 45">大分県</template>
              <template v-if="list.pref === 46">鹿児島県</template>
              <template v-if="list.pref === 47">沖縄県</template>
            </td-c>
          </template>
          <template v-if="address"><td-c>{{list.address}}</td-c></template>
          <template v-if="tel1"><td-c>{{list.tel1}}</td-c></template>
          <template v-if="tel2"><td-c>{{list.tel2}}</td-c></template>
          <template v-if="contact_date"><td-c>{{list.contact_date}}</td-c></template>
          <template v-if="support">
            <td-c v-if="list.support === 0">未選択</td-c>
            <td-c v-if="list.support === 1">獲得</td-c>
            <td-c v-if="list.support === 2">逃し</td-c>
            <td-c v-if="list.support === 3">断り</td-c>
            <td-c v-if="list.support === 4">APCXL</td-c>
            <td-c v-if="list.support === 5">ツブレ</td-c>
          </template>
          <template v-if="result">
            <td-c v-if="list.result === 0">未選択</td-c>
            <td-c v-if="list.result === 1">契約</td-c>
            <td-c v-if="list.result === 2">のみ</td-c>
            <td-c v-if="list.result === 3">保留</td-c>
            <td-c v-if="list.result === 4">ツブレ</td-c>
            <td-c v-if="list.result === 5">ズレ</td-c>
            <td-c v-if="list.result === 6">再営業</td-c>
          </template>
          <template v-if="acquisition_date"><td-c>{{list.acquisition_date}}</td-c></template>
          <template v-if="ap_type">
            <td-c v-if="list.ap_type === 0">未選択</td-c>
            <td-c v-if="list.ap_type === 1">体験希望</td-c>
            <td-c v-if="list.ap_type === 2">資料請求</td-c>
            <td-c v-if="list.ap_type === 3">問い合わせ</td-c>
          </template>
          <template v-if="medium">
            <td-c v-if="list.medium === 0">未選択</td-c>
            <td-c v-if="list.medium === 1">DM</td-c>
            <td-c v-if="list.medium === 2">貼紙</td-c>
            <td-c v-if="list.medium === 3">HP</td-c>
            <td-c v-if="list.medium === 4">紹介</td-c>
            <td-c v-if="list.medium === 5">TEL注</td-c>
            <td-c v-if="list.medium === 6">TA</td-c>
            <td-c v-if="list.medium === 7">その他</td-c>
          </template>
          <template v-if="hp_type">
            <td-c v-if="list.hp_type === 0">未選択</td-c>
            <td-c v-if="list.hp_type === 1">自社</td-c>
            <td-c v-if="list.hp_type === 2">リスティング</td-c>
          </template>
          <template v-if="office_id">
            <td-c v-if="list.office_id === 0">未選択</td-c>
            <td-c v-if="list.office_id === 1">仙台</td-c>
            <td-c v-if="list.office_id === 2">札幌</td-c>
            <td-c v-if="list.office_id === 3">名古屋</td-c>
            <td-c v-if="list.office_id === 4">福岡</td-c>
            <td-c v-if="list.office_id === 5">新宿</td-c>
            <td-c v-if="list.office_id === 6">大宮</td-c>
            <td-c v-if="list.office_id === 7">高松</td-c>
            <td-c v-if="list.office_id === 8">高崎</td-c>
            <td-c v-if="list.office_id === 9">東京</td-c>
            <td-c v-if="list.office_id === 10">大阪</td-c>
          </template>
          <template v-if="gender">
            <td-c v-if="list.gender === 0">未選択</td-c>
            <td-c v-if="list.gender === 1">男</td-c>
            <td-c v-if="list.gender === 2">女</td-c>
          </template>
          <template v-if="school_type">
            <td-c v-if="list.school_type === 0">未選択</td-c>
            <td-c v-if="list.school_type === 1">公立</td-c>
            <td-c v-if="list.school_type === 2">国立</td-c>
            <td-c v-if="list.school_type === 3">私立</td-c>
            <td-c v-if="list.school_type === 4">その他</td-c>
          </template>
          <template v-if="school_stage">
            <td-c v-if="list.school_stage === 0">未選択</td-c>
            <td-c v-if="list.school_stage === 1">小学</td-c>
            <td-c v-if="list.school_stage === 2">中学</td-c>
            <td-c v-if="list.school_stage === 3">高校</td-c>
            <td-c v-if="list.school_stage === 4">幼稚園</td-c>
            <td-c v-if="list.school_stage === 5">その他</td-c>
          </template>
          <template v-if="grade">
            <td-c v-if="list.grade === 0">未選択</td-c>
            <td-c v-if="list.grade === 1">1</td-c>
            <td-c v-if="list.grade === 2">2</td-c>
            <td-c v-if="list.grade === 3">3</td-c>
            <td-c v-if="list.grade === 4">4</td-c>
            <td-c v-if="list.grade === 5">5</td-c>
            <td-c v-if="list.grade === 6">6</td-c>
          </template>
          <template v-if="memo"><td-c>{{list.memo}}</td-c></template>
          <template v-if="dm"><td-c>{{list.dm}}</td-c></template>
          <template v-if="shop_type">
            <td-c v-if="list.shop_type === 0">未選択</td-c>
            <td-c v-if="list.shop_type === 1">スーパー</td-c>
            <td-c v-if="list.shop_type === 2">ドラッグストア</td-c>
            <td-c v-if="list.shop_type === 3">調剤薬局</td-c>
            <td-c v-if="list.shop_type === 4">100円ショップ</td-c>
            <td-c v-if="list.shop_type === 5">郵便局</td-c>
            <td-c v-if="list.shop_type === 6">銀行</td-c>
            <td-c v-if="list.shop_type === 7">ディスカウントストア</td-c>
            <td-c v-if="list.shop_type === 8">パン屋</td-c>
            <td-c v-if="list.shop_type === 9">病院</td-c>
            <td-c v-if="list.shop_type === 10">コンビニ</td-c>
            <td-c v-if="list.shop_type === 11">ラーメン・そば系</td-c>
            <td-c v-if="list.shop_type === 12">その他飲食店</td-c>
            <td-c v-if="list.shop_type === 13">弁当屋</td-c>
            <td-c v-if="list.shop_type === 14">携帯ショップ</td-c>
            <td-c v-if="list.shop_type === 15">クリーニング屋</td-c>
            <td-c v-if="list.shop_type === 16">本屋</td-c>
            <td-c v-if="list.shop_type === 17">個人商店</td-c>
            <td-c v-if="list.shop_type === 18">娯楽施設</td-c>
            <td-c v-if="list.shop_type === 19">A</td-c>
            <td-c v-if="list.shop_type === 20">B</td-c>
            <td-c v-if="list.shop_type === 21">C</td-c>
            <td-c v-if="list.shop_type === 22">D</td-c>
            <td-c v-if="list.shop_type === 23">E</td-c>
            <td-c v-if="list.shop_type === 24">F</td-c>
            <td-c v-if="list.shop_type === 25">G</td-c>
            <td-c v-if="list.shop_type === 26">H</td-c>
            <td-c v-if="list.shop_type === 27">I</td-c>
            <td-c v-if="list.shop_type === 28">J</td-c>
            <td-c v-if="list.shop_type === 29">K</td-c>
            <td-c v-if="list.shop_type === 30">L</td-c>
          </template>
          <template v-if="shop_name"><td-c>{{list.shop_name}}</td-c></template>
          <template v-if="hp_browse">
            <td-c v-if="list.hp_browse === 0">未選択</td-c>
            <td-c v-if="list.hp_browse === 1">PC</td-c>
            <td-c v-if="list.hp_browse === 2">SmartPhone</td-c>
            <td-c v-if="list.hp_browse === 3">両方</td-c>
            <td-c v-if="list.hp_browse === 4">非閲覧</td-c>
          </template>
          <template v-if="visit_date"><td-c>{{list.visit_date}}</td-c></template>
          <template v-if="note"><td-c>{{list.note}}</td-c></template>
          <template v-if="created_at"><td-c>{{list.created_at.substring(0, 10)}}</td-c></template>
        </tr-c>
      </table-c>
    </div>
  </div>
</template>

<script>
let _ = window._
export default {
  props: {
    family: Object
  },
  computed: {
    // order By
    orderedFamilyfiles () {
      if (this.sortState === '' || this.sortState === 'asc') {
        return _.orderBy(this.family.appointments, this.asc)
      } else if (this.sortState === 'desc') {
        return _.orderBy(this.family.appointments, this.desc).reverse()
      }
    },

    // filter By
    FilteredFamilyAppointments () {
      var self = this // function の中でthisが使えないのでselfに置き換え
      var key = Object.keys(this.searchQuery) // ["id", "student_id",・・・]
      console.log(key)
      let isSearch = key.every((e) => {
        if (!self.searchQuery[e]) {
          return true // default (全てfalseの場合)
        } else {
          return false // search 何か入力されてたらsearch
        }
      })
      // console.log(isSearch)
      if (isSearch) {
        return self.family.appointments // 全部返す
      }
      // isSearch じゃなければfilterする
      return self.family.appointments.filter((el) => {
        let re = [] // 正規表現の配列
        for (var i = 0; i < key.length; i++) {
          re.push(new RegExp(self.searchQuery[key[i]]))
        }
        // console.log(re)

        let els = [] // 正規表現と入力された値をtest関数で比べて返ってきたtrue,falseの配列
        for (var t = 0; t < key.length; t++) {
          let column = key[t]
          let input = el[[column]]
          els.push(re[t].test(input))
        }
        // console.log(els)

        let flg = els.every((el) => {
          if (el) {
            return true
          } else {
            return false
          }
        })
        // console.log(flg)
        return flg
      })
    },

    notFilteredFamilyAppointments () {
      var self = this // function の中でthisが使えないのでselfに置き換え
      var key = Object.keys(this.notSearchQuery) // ["id", "student_id",・・・]
      // console.log(key)
      let isSearch = key.every((e) => {
        if (!self.notSearchQuery[e]) {
          return true // default (全てfalseの場合)
        } else {
          return false // search 何か入力されてたらsearch
        }
      })
      // console.log(isSearch)
      if (isSearch) {
        return self.FilteredFamilyAppointments // 全部返す FilteredContractsを返す
      }
      // isSearch じゃなければfilterする
      return self.FilteredFamilyAppointments.filter((el) => { // FilteredContractsにfilterをかける
        let re = [] // 正規表現の配列
        for (var i = 0; i < key.length; i++) {
          re.push(new RegExp(self.notSearchQuery[key[i]]))
        }
        // console.log(re)

        let els = [] // 正規表現と入力された値をtest関数で比べて返ってきたtrue,falseの配列
        for (var t = 0; t < key.length; t++) {
          let column = key[t]
          let input = el[[column]]
          els.push(re[t].test(input))
        }
        // console.log(els)

        let flg = els.every((el) => {
          if (el) {
            return true
          } else {
            return false
          }
        })
        // console.log(flg)
        return !flg // 反転
      })
    }
  },
  data () {
    return {
      column: false,
      asc: '',
      desc: '',
      sortState: '',
      searchType: '',

      id: true,
      family_id: true,
      user_id: true,
      state: true,
      name: true,
      kana: true,
      zip: true,
      pref: true,
      address: true,
      tel1: true,
      tel2: true,
      contact_date: true,
      support: true,
      result: true,
      acquisition_date: true,
      ap_type: true,
      medium: true,
      hp_type: true,
      office_id: true,
      gender: true,
      school_type: true,
      school_stage: true,
      grade: true,
      memo: true,
      dm: true,
      shop_type: true,
      shop_name: true,
      hp_browse: true,
      visit_date: true,
      note: false,
      created_at: true,

      searchQuery: {
        id: '',
        family_id: '',
        user_id: '',
        state: '',
        name: '',
        kana: '',
        zip: '',
        pref: '',
        address: '',
        tel1: '',
        tel2: '',
        contact_date: '',
        support: '',
        result: '',
        acquisition_date: '',
        ap_type: '',
        medium: '',
        hp_type: '',
        office_id: '',
        gender: '',
        school_type: '',
        school_stage: '',
        grade: '',
        memo: '',
        dm: '',
        shop_type: '',
        shop_name: '',
        hp_browse: '',
        visit_date: '',
        note: '',
        created_at: ''
      },

      notSearchQuery: {
        id: '',
        family_id: '',
        user_id: '',
        state: '',
        name: '',
        kana: '',
        zip: '',
        pref: '',
        address: '',
        tel1: '',
        tel2: '',
        contact_date: '',
        support: '',
        result: '',
        acquisition_date: '',
        ap_type: '',
        medium: '',
        hp_type: '',
        office_id: '',
        gender: '',
        school_type: '',
        school_stage: '',
        grade: '',
        memo: '',
        dm: '',
        shop_type: '',
        shop_name: '',
        hp_browse: '',
        visit_date: '',
        note: '',
        created_at: ''
      }
    }
  },
  methods: {
    linkFamilyAppointment (list) {
      this.$router.push({name: 'appointmentindex', params: { id: list.id }})
    },

    switchV (col) {
      this[col] = !this[col]
    },

    reset () {
      this.id = false
      this.family_id = false
      this.user_id = false
      this.state = false
      this.name = false
      this.kana = false
      this.zip = false
      this.pref = false
      this.address = false
      this.tel1 = false
      this.tel2 = false
      this.contact_date = false
      this.support = false
      this.result = false
      this.acquisition_date = false
      this.ap_type = false
      this.medium = false
      this.hp_type = false
      this.office_id = false
      this.gender = false
      this.school_type = false
      this.school_stage = false
      this.grade = false
      this.memo = false
      this.dm = false
      this.shop_type = false
      this.shop_name = false
      this.hp_browse = false
      this.visit_date = false
      this.note = false
      this.created_at = false
    },

    all () {
      this.id = true
      this.family_id = true
      this.user_id = true
      this.state = true
      this.name = true
      this.kana = true
      this.zip = true
      this.pref = true
      this.address = true
      this.tel1 = true
      this.tel2 = true
      this.contact_date = true
      this.support = true
      this.result = true
      this.acquisition_date = true
      this.ap_type = true
      this.medium = true
      this.hp_type = true
      this.office_id = true
      this.gender = true
      this.school_type = true
      this.school_stage = true
      this.grade = true
      this.memo = true
      this.dm = true
      this.shop_type = true
      this.shop_name = true
      this.hp_browse = true
      this.visit_date = true
      this.note = true
      this.created_at = true
    },

    // order By
    sort (header) {
      if (this.sortState === '' || this.sortState === 'desc') {
        this.sortState = 'asc'
        this.asc = header
      } else if (this.sortState === 'asc') {
        this.sortState = 'desc'
        this.desc = header
      }
    }

    // offset (e) {
    //   this.$store.dispatch('SCROLL', {
    //     this: this,
    //     e: e,
    //     obj: obj
    //   })
    // },

    // searchTable (e) {
    //   this.$store.dispatch('SEARCH', {
    //     this: this,
    //     e: e,
    //     obj: obj
    //   })
    // },
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang="scss" scoped>
.m-label-custom {
  z-index: 1;
  cursor: pointer;
  margin-bottom: 1px;
}
.slideActive {
  background: #455A64;
  color: #fff;
}
.active {
  background: #455A64;
  border: solid 1px #455A64;
  color: #fff;
}
.resetSearch {
  padding: 7px 0;
}
.table {
  margin-top: 0 !important;
}
.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
}
.th {
  cursor: pointer;
}
input {
  width: 100%;
  min-width: 100px;
  height: 100%;
  padding: 0;
  outline: 0;
  border: none;
}
.index-box {
  height: calc(100vh - 150px);
  overflow: scroll;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// FamilyAppointmentView.vue?2629a045